export default {
  switchAccount: "Changer de Compte",
  login: "Se connecter",
  loginFirst: "Veuillez vous connecter d’abord",
  start: "Commencer",
  hasHistory: "Vous avez déjà répondu à certaines des questions.",
  loadHistory: "Voulez-vous continuer ?",
  cancel: "Non",
  confirm: "Oui",
  contact:
    "Laissez vos coordonnées pour avoir une chance de gagner des récompenses bonus !",
  completed: "Vous avez répondu à l'enquête !",
  leaveMessage:
    "Laissez vos coordonnées pour avoir une chance de gagner des récompenses bonus !",
  enterEmail: "E-mail :",
  enterPhone: "Téléphone :",
  submit: "Soumettre",
  leave: "Quitter",
  submitted: "Soumis",
  thanks: "Merci !",
  opinion: "Quelle est votre opinion ?",
  prev: "Précédent",
  next: "Suivant",
  unlikely: "Très peu probable",
  likely: "Très probable",
  claimYourRewards: "Vous pouvez réclamer vos récompenses.",
  rewardSent: "Récompenses envoyées.",
  checkInGame: "Veuillez les réclamer dans le jeu.",
  copy: "Copier",
  copied: "Copié !",
  selectTips: "Veuillez sélectionner la meilleure réponse.",
  multipleTips: "Vous pouvez sélectionner plusieurs réponses.",
  leastChoose: "Sélectionnez jusqu'à xxx réponses",
  maxChoose: "Sélectionnez au moins xxx réponses.",
  mustAnswer: "Veuillez d'abord répondre à la question en cours.",
  mustWrite: "Veuillez écrire quelque chose.",
  checkEmail: "Veuillez saisir une adresse e-mail valide.",
  checkPhone: "Veuillez saisir un numéro de téléphone valide.",
  isAnswer: "Vous avez déjà répondu au sondage.",
  unStart: "Évent indisponible",
  end: "Évent est terminé",
  server: "Choisissez votre serveur",
  role: "Choisissez votre personnage",
  common: "Système occupé. Veuillez réessayer plus tard.",
  title: "Questionnaire",
  titleAward: "Sondage",
  leastWord: "Veuillez saisir au moins xxx caractères.",
  maxWord: "Limite de caractères (xxx) dépassée !",
  singleChoose: "Réponse Unique",
  multiChoose: "Réponse Multiple",
  matrix: "Question Matricielle",
  score: "Note",
  textLimit: "(xx-yyy caractères)",
  coverGiftTitle: "Terminer l'Enquête pour Réclamer un Cadeau",
  "-20001": "Non connecté",
  "-20002": "Paramètres requis manquants",
  "-20003": "Questionnaire introuvable",
  "-20004": "Configuration du questionnaire en cours",
  "-20005": "Questionnaire arrêté",
  "-20006": "Événement du questionnaire non démarré",
  "-20007": "Événement du questionnaire terminé",
  "-20008": "Déjà répondu",
  "-20010": "Distribution des récompenses échouée",
  "-20011": "Récompense déjà distribuée pour ce questionnaire",
  "-20012": "Pas encore répondu",
  "-20016": "ID de jeu invalide",
};
